import React from 'react';
import getColor from '../../utils/interpolateColor';
import { getProgressBarFillPercent } from '../../utils/progressBarDisplayWidth';
import ParameterIcon from '../../components/ParameterIcon.jsx';
import { useTranslation } from '../../hooks/useTranslation';

const ProgressBar = ({ value = 0, label = '', darkMode = false, highlight = false, iconSize = 48 }) => {
  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const barColor = getColor(clamped);
  const percentage = getProgressBarFillPercent(clamped);
  const { t } = useTranslation();

  return (
    <div className={`relative w-full rounded-full border border-gray-200 ${highlight ? 'bg-yellow-100' : 'bg-gray-100'} overflow-hidden`}>
      {!highlight && (
        <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${percentage}%`, backgroundColor: barColor }} />
      )}
      {/* Consupedia padding: no left padding when icon is present */}
      <div className="relative z-10 flex items-center justify-between min-w-0" style={{ padding: '0 4px 0 0' }}>
        <div className="flex items-center space-x-1.5 min-w-0 flex-1 shrink">
          <ParameterIcon title={label} width={iconSize} height={iconSize} />
          <span className={`text-sm font-normal truncate ${darkMode ? 'text-gray-800' : 'text-gray-900'}`} title={t(label)}>{t(label)}</span>
        </div>
        <span className={`text-sm font-black flex-shrink-0 ${darkMode ? 'text-gray-900' : 'text-gray-900'}`}>{Math.round(clamped)}/100</span>
      </div>
    </div>
  );
};

const ReportProgressBarComponents = ({ items = [], darkMode = false, sectionNote = '', groupKey = '', highlightIndex = null, iconSize = 48 }) => {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="space-y-1">
      {sectionNote ? (
        <div className={`text-[0.60rem] font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-700'} mb-1`}>{sectionNote}</div>
      ) : null}
      {items.map((it, idx) => (
        <ProgressBar key={it.key} value={it.value} label={it.label} darkMode={darkMode} highlight={highlightIndex === idx} iconSize={iconSize} />
      ))}
    </div>
  );
};

export default ReportProgressBarComponents;


